import React from 'react';
import { formatPrice } from './utils/priceFormatter';
import './Home2.css';

function Home2() {
  return (
    <div className="App home2-white">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="wave-container">
          <svg className="wave wave-bottom" viewBox="0 0 1440 320" preserveAspectRatio="none">
            <path fill="url(#gradient1)" d="M0,96L48,112C96,128,192,160,288,165.3C384,171,480,149,576,133.3C672,117,768,107,864,112C960,117,1056,139,1152,149.3C1248,160,1344,160,1392,160L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            <defs>
              <linearGradient id="gradient1" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#20B2AA" stopOpacity="0.8"/>
                <stop offset="100%" stopColor="#008B8B" stopOpacity="0.9"/>
              </linearGradient>
            </defs>
          </svg>
          <svg className="wave wave-middle" viewBox="0 0 1440 320" preserveAspectRatio="none">
            <path fill="url(#gradient2)" d="M0,160L48,170.7C96,181,192,203,288,208C384,213,480,203,576,186.7C672,171,768,149,864,154.7C960,160,1056,192,1152,197.3C1248,203,1344,181,1392,170.7L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            <defs>
              <linearGradient id="gradient2" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#1E3A8A" stopOpacity="0.7"/>
                <stop offset="100%" stopColor="#1E40AF" stopOpacity="0.8"/>
              </linearGradient>
            </defs>
          </svg>
          <svg className="wave wave-top" viewBox="0 0 1440 320" preserveAspectRatio="none">
            <path fill="url(#gradient3)" d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,213.3C672,224,768,224,864,208C960,192,1056,160,1152,154.7C1248,149,1344,171,1392,181.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            <defs>
              <linearGradient id="gradient3" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#7C3AED" stopOpacity="0.6"/>
                <stop offset="100%" stopColor="#8B5CF6" stopOpacity="0.7"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className="sun-moon-glow"></div>
        <div className="hero-content">
          <h1 className="brand-name">
            <span className="mana-text">Mana</span>
            <span className="wave-text">Wave</span>
          </h1>
          <p className="tagline">Flow into your energy</p>
          <div className="hero-cta">
            <button className="btn-primary">Explore Services</button>
            <button className="btn-secondary">Book a Session</button>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section">
        <div className="container">
          <div className="intro-content-wrapper">
            <div className="intro-image-container">
              <img 
                src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80" 
                alt="Spiritual wellness and meditation" 
                className="intro-image"
              />
            </div>
            <div className="section-content">
              <h2 className="section-title">Welcome to ManaWave</h2>
              <p className="section-text">
                ManaWave is a sanctuary for energy healing and spiritual wellness. Through the ancient practice of Reiki and universal energy work, we guide you toward balance, healing, and alignment. Experience the gentle flow of energy that connects mind, body, and spirit, creating harmony within and around you.
              </p>
            </div>
          </div>
        </div>
        <div className="wave-separator wave-separator-1"></div>
      </section>

      {/* What Is Reiki Section */}
      <section className="reiki-section">
        <div className="container">
          <div className="card">
            <div className="reiki-image-container">
              <img 
                src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80" 
                alt="Spiritual energy flow" 
                className="reiki-image"
              />
            </div>
            <h2 className="section-title">What Is Reiki & Universal Energy</h2>
            <p className="section-text">
              Reiki is a Japanese healing technique that channels universal life force energy through gentle touch or intention. This energy flows naturally through all living things, promoting physical, emotional, and spiritual healing. At ManaWave, we work with this universal energy to help restore balance, release blockages, and support your natural healing process.
            </p>
          </div>
        </div>
        <div className="wave-separator wave-separator-2"></div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works-section">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-icon">1</div>
              <h3>Choose a Service</h3>
              <p>Select from our range of energy healing sessions tailored to your needs.</p>
            </div>
            <div className="step-card">
              <div className="step-icon">2</div>
              <h3>Book in Advance</h3>
              <p>Schedule your session at a time that works best for your journey.</p>
            </div>
            <div className="step-card">
              <div className="step-icon">3</div>
              <h3>Energy Work</h3>
              <p>Receive healing energy remotely or through guided on-call sessions.</p>
            </div>
            <div className="step-card">
              <div className="step-icon">4</div>
              <h3>Integration & Support</h3>
              <p>Continue your healing journey with ongoing guidance and support.</p>
            </div>
          </div>
        </div>
        <div className="wave-separator wave-separator-3"></div>
      </section>

      {/* Services Preview Section */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <img 
                src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80" 
                alt="Reiki healing energy" 
                className="service-image"
              />
              <h3>Reiki Healing Session</h3>
              <p className="service-duration">60 minutes</p>
              <p className="service-price">{formatPrice('$120')}</p>
            </div>
            <div className="service-card">
              <img 
                src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&q=80" 
                alt="Chakra energy" 
                className="service-image"
              />
              <h3>Chakra Balancing</h3>
              <p className="service-duration">45 minutes</p>
              <p className="service-price">{formatPrice('$95')}</p>
            </div>
            <div className="service-card">
              <img 
                src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=600&fit=crop&auto=format" 
                alt="Energy flow" 
                className="service-image"
                onError={(e) => {
                  e.target.src = 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&h=600&fit=crop&auto=format';
                }}
              />
              <h3>Distance Energy Healing</h3>
              <p className="service-duration">30 minutes</p>
              <p className="service-price">{formatPrice('$75')}</p>
            </div>
            <div className="service-card">
              <img 
                src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80" 
                alt="Meditation and mindfulness" 
                className="service-image"
              />
              <h3>Guided Meditation</h3>
              <p className="service-duration">30 minutes</p>
              <p className="service-price">{formatPrice('$60')}</p>
            </div>
          </div>
          <button className="btn-view-all">View All Services</button>
        </div>
        <div className="wave-separator wave-separator-4"></div>
      </section>

      {/* Why Try Energy Work Section */}
      <section className="benefits-section">
        <div className="container">
          <h2 className="section-title">Why Try Energy Work</h2>
          <div className="benefits-list">
            <div className="benefit-item">
              <div className="benefit-glow"></div>
              <h3>Emotional Balance</h3>
              <p>Release emotional blockages and find inner peace through gentle energy healing.</p>
            </div>
            <div className="benefit-separator"></div>
            <div className="benefit-item">
              <div className="benefit-glow"></div>
              <h3>Mental Clarity</h3>
              <p>Clear mental fog and enhance focus with balanced energy flow throughout your being.</p>
            </div>
            <div className="benefit-separator"></div>
            <div className="benefit-item">
              <div className="benefit-glow"></div>
              <h3>Spiritual Alignment</h3>
              <p>Connect with your higher self and align with your true purpose and path.</p>
            </div>
            <div className="benefit-separator"></div>
            <div className="benefit-item">
              <div className="benefit-glow"></div>
              <h3>Physical Wellbeing</h3>
              <p>Support your body's natural healing processes and promote overall wellness.</p>
            </div>
          </div>
        </div>
        <div className="wave-separator wave-separator-5"></div>
      </section>

      {/* Guided & Remote Sessions Section */}
      <section className="sessions-section">
        <div className="container">
          <h2 className="section-title">Guided & Remote Sessions</h2>
          <div className="sessions-grid">
            <div className="session-type-card">
              <img 
                src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=600&fit=crop&auto=format" 
                alt="Remote energy healing" 
                className="session-image"
                onError={(e) => {
                  e.target.src = 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&h=600&fit=crop&auto=format';
                }}
              />
              <h3>Remote Energy Sessions</h3>
              <p>Receive healing energy from anywhere in the world. Our practitioners channel universal energy to you remotely, creating a powerful connection that transcends physical distance. Perfect for those seeking flexibility and comfort.</p>
            </div>
            <div className="session-type-card">
              <img 
                src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80" 
                alt="Guided healing session" 
                className="session-image"
              />
              <h3>On-Call Guided Sessions</h3>
              <p>Experience personalized guidance during your session. Connect via phone or video call as our practitioners guide you through the healing process, offering real-time support and insights.</p>
            </div>
          </div>
        </div>
        <div className="wave-separator wave-separator-6"></div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <h2 className="section-title">Energy Experiences</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-blur"></div>
              <p className="testimonial-text">"A transformative experience that brought deep peace and clarity."</p>
              <p className="testimonial-author">— Coming Soon</p>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-blur"></div>
              <p className="testimonial-text">"The energy flow was gentle yet powerful, leaving me feeling renewed."</p>
              <p className="testimonial-author">— Coming Soon</p>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-blur"></div>
              <p className="testimonial-text">"ManaWave helped me find balance I didn't know I was missing."</p>
              <p className="testimonial-author">— Coming Soon</p>
            </div>
          </div>
        </div>
        <div className="wave-separator wave-separator-7"></div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">Begin Your Journey</h2>
          <p className="cta-text">Take the first step toward balance, healing, and alignment. Your energy journey awaits.</p>
          <button className="btn-cta">Start Your Session</button>
        </div>
      </section>
    </div>
  );
}

export default Home2;
